export const SUITE_APPS = [
  {
    label: "Work Management",
    description: "Tasks, projects, MOMs & workflows",
    icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7l2 2 4-4",
    color: "#0b72b9",
    softColor: "rgba(11, 114, 185, 0.10)",
    path: "/dashboard",
    moduleKey: "task-management",
    implemented: true,
    activePaths: [
      "/dashboard",
      "/tasks",
      "/projects",
      "/moms",
      "/users",
      "/departments",
      "/audit",
      "/validations",
      "/timeline-requests",
      "/team",
    ],
  },
  {
    label: "CRM",
    description: "Pipeline, contacts & deal tracking",
    icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z",
    color: "#2563eb",
    softColor: "rgba(37, 99, 235, 0.10)",
    path: "/crm",
    moduleKey: "crm",
    implemented: true,
    activePaths: ["/crm"],
  },
  {
    label: "HRMS",
    description: "Employees, attendance & leaves",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
    color: "#059669",
    softColor: "rgba(5, 150, 105, 0.10)",
    path: "/hrms",
    moduleKey: "hrms",
    implemented: true,
    activePaths: ["/hrms"],
  },
  {
    label: "Finance & Admin",
    description: "Invoices, budgets, vendors & approvals",
    icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    color: "#d97706",
    softColor: "rgba(217, 119, 6, 0.10)",
    path: "/finance",
    moduleKey: "finance",
    implemented: true,
    activePaths: ["/finance"],
  },
  {
    label: "Client Portal",
    description: "Projects, requests, approvals & invoices",
    icon: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    color: "#7c3aed",
    softColor: "rgba(124, 58, 237, 0.10)",
    path: "/client-portal",
    moduleKey: "client-portal",
    implemented: true,
    activePaths: ["/client-portal"],
  },
  {
    label: "Analytics",
    description: "Reports, charts & business insights",
    icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
    color: "#db2777",
    softColor: "rgba(219, 39, 119, 0.10)",
    path: "/analytics",
    moduleKey: "analytics",
    implemented: false,
    activePaths: ["/analytics"],
  },
  {
    label: "Documents",
    description: "Files, folders & knowledge base",
    icon: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z",
    color: "#0891b2",
    softColor: "rgba(8, 145, 178, 0.10)",
    path: "/documents",
    moduleKey: "documents",
    implemented: false,
    hidden: true,
    activePaths: ["/documents"],
  },
  {
    label: "Support Desk",
    description: "Tickets, SLAs & customer support",
    icon: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z",
    color: "#ea580c",
    softColor: "rgba(234, 88, 12, 0.10)",
    path: "/support",
    moduleKey: "support",
    implemented: false,
    activePaths: ["/support"],
  },
  {
    label: "Communication",
    description: "Team chat, threads & announcements",
    icon: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
    color: "#06b6d4",
    softColor: "rgba(6, 182, 212, 0.10)",
    path: "/comms",
    moduleKey: "comms",
    implemented: false,
    activePaths: ["/comms"],
  },
  {
    label: "Inventory",
    description: "Stock, warehouses & asset tracking",
    icon: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4",
    color: "#4f46e5",
    softColor: "rgba(79, 70, 229, 0.10)",
    path: "/inventory",
    moduleKey: "inventory",
    implemented: false,
    hidden: true,
    activePaths: ["/inventory"],
  },
  {
    label: "Procurement",
    description: "POs, vendors & supplier management",
    icon: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z",
    color: "#be123c",
    softColor: "rgba(190, 18, 60, 0.10)",
    path: "/procurement",
    moduleKey: "procurement",
    implemented: false,
    hidden: true,
    activePaths: ["/procurement"],
  },
  {
    label: "Marketplace",
    description: "Integrations, plugins & extensions",
    icon: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z",
    color: "#475569",
    softColor: "rgba(71, 85, 105, 0.12)",
    path: "/marketplace",
    moduleKey: "marketplace",
    implemented: false,
    hidden: true,
    activePaths: ["/marketplace"],
  },
];

export const IMPLEMENTED_SUITE_APPS = SUITE_APPS.filter((app) => app.implemented);

export function getActiveModuleKey(pathname = "") {
  const path = pathname.split("?")[0] || "/";
  const activeApp = SUITE_APPS.find((app) =>
    app.activePaths.some(
      (activePath) => path === activePath || path.startsWith(`${activePath}/`)
    )
  );
  return activeApp?.moduleKey ?? null;
}
